import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, Typography, Box } from "@mui/material";
import { ContainedButton } from "components/ContainedButton";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean,
  onClose: () => void
}

export const AlertUploadFile: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} maxWidth="xs" onClose={onClose}>
      <Box style={{ padding: "1.7rem", textAlign: "center", display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Box style={{ backgroundColor: "#f3e6dd", borderRadius: "15rem", padding: "1rem", width: "4rem", alignSelf: "center" }}>
          <FontAwesomeIcon
            icon="file-upload"
            color="#FB8C00"
            size="2x"
          />
        </Box>
        <Typography variant="h6" color="primary" style={{ fontWeight: "bold" }}>{t('documents:fileUploadInProgress')}</Typography>
        <Typography>
          {t('documents:fileUploadMessage')}
        </Typography>
        <Typography>
          {t('documents:reloadPageMessage')}
        </Typography>
        <ContainedButton
          text={t('common:gotIt')}
          backgroundColor="#FB8C00"
          textColor="#ffffff"
          width="100%"
          onClick={onClose}
        />
      </Box>
    </Dialog>
  );
};